import React from "react";
import { useNavigate } from "react-router-dom";

function CreateKandiPage() {
  const navigate = useNavigate();

  return (
    <div className="scan-container">
      <div className="scan-card">
        <h1>Create Kandi</h1>
        <p className="scan-subtitle">
          For now, use the Scan page to register new kandi with pre-programmed
          NFC tags
        </p>

        <button onClick={() => navigate("/scan")} className="check-btn">
          Go to Scan Page
        </button>
      </div>
    </div>
  );
}

export default CreateKandiPage;
